"use strict";

define('uikit/collections/checkbox.group',['marionette', 'underscore', '../channel', '../mixins/component.mixin', '../elements/checkbox'], function (Mn, _, channel, ComponentMixin, Checkbox) {
  var CheckboxGroup = Mn.CollectionView.extend(ComponentMixin).extend({
    childView: Checkbox,
    className: 'grouped fields',
    childViewOptions: function childViewOptions() {
      return {
        radio: this.getBoolOption('radio'),
        bindings: _.clone(this.childBindings)
      };
    },
    options: {
      visible: true,
      value: '',
      inline: false,
      wrap: true,
      radio: false
    },
    update: {
      visible: false,
      radio: false,
      value: false,
      inline: false
    },
    bindings: {},
    onFirstRender: function onFirstRender() {
      this.listenTo(this.vent, 'change:value', function () {
        var value = this.value;
        if (this.getOption('radio')) {
          this.children.each(function (view) {
            if (view.model === value) {
              view.value = true;
            } else {
              view.value = false;
            }
          });
        }
      });
      this.listenTo(this, 'childview:change:value', function (view) {
        if (this.getOption('radio')) {
          if (view.value === true) {
            var children = this.children.without(view);
            _.each(children, function (v) {
              v.value = false;
            });
            this._internal.value = view.model;
          }
        } else {
          if (view.value === true) {
            this.value.add(view.model);
          } else {
            this.value.remove(view.model);
          }
        }
      });
      this.listenTo(this.vent, 'change:radio', _.debounce(this.initializeValue, 10));
      this.initializeValue();
    },
    initializeValue: function initializeValue() {
      if (this.getOption('radio')) {
        var model = this.value;
        if (model && model instanceof Backbone.Collection) {
          this.stopListening(model);
          this._setOption('value', model.at(0));
        } else if (model && model instanceof Backbone.Model) {
          this._setOption('value', model);
        } else {
          this._setOption('value', null);
        }
      } else {
        var model = this.value;
        if (!(model instanceof Backbone.Collection)) {
          this._internal.value = new Backbone.Collection();
        }
        this.listenTo(this.options.value, 'add remove reset change update', _.debounce(this.updateChildCheckboxes, 10));
        this.listenTo(this.options.value, 'add remove reset change update', function () {
          this.trigger('change:value', this, this.options.value);
          this.trigger('change', this, 'value', this.options.value);
        });
        if (model && model instanceof Backbone.Model) {
          this.options.value.add(model);
        }
        this.updateChildCheckboxes();
      }
      this.collection.each(function (child) {
        var view = this.children.findByModel(child);
        if (view) {
          view.radio = this.getOption('radio');
        }
      }, this);
    },
    updateChildCheckboxes: function updateChildCheckboxes() {
      var collection = this.options.value;
      this.children.each(function (view) {
        if (collection.contains(view.model)) {
          view.value = true;
        } else {
          view.value = false;
        }
      });
    },
    onAddChild: function onAddChild(view) {
      if (this.getBoolOption('radio')) {
        view.value = view.model === this.value;
      } else if (this.value instanceof Backbone.Collection) {
        if (this.value.contains(view.model)) {
          view.value = true;
        }
      }
    },
    updateAttributes: function updateAttributes() {
      this.addClass('inline', this.getOption('inline'));
    },
    createWrapperElement: function createWrapperElement() {
      return $('<div/>').addClass('field');
    },
    childElement: function childElement(childView) {
      if (this.getOption('wrap')) {
        var div = this.createWrapperElement().append(childView.el);
        this.listenToOnce(childView, 'destroy', function () {
          div.remove();
        });
        return div.get(0);
      } else {
        return childView.el;
      }
    },
    _createBuffer: function _createBuffer(collectionView) {
      var elBuffer = document.createDocumentFragment();
      _.each(collectionView._bufferedChildren, function (b) {
        elBuffer.appendChild(this.childElement(b));
      }, this);
      return elBuffer;
    },
    _insertBefore: function _insertBefore(childView, index) {
      var currentView;
      var findPosition = this.getOption('sort') && index < this.children.length - 1;
      if (findPosition) {
        currentView = this.children.find(function (view) {
          return view._index === index + 1;
        });
      }
      if (currentView) {
        currentView.$el.before(this.childElement(childView));
        return true;
      }
      return false;
    },
    _insertAfter: function _insertAfter(childView) {
      this.$el.append(this.childElement(childView));
    }
  });
  channel.reply('checkbox-group', function () {
    return CheckboxGroup;
  });
  return CheckboxGroup;
});

